import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=50fce98a&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=50fce98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fce98a",
  null
  
)

export default component.exports